import { Link } from "react-router-dom";
import { Button, useSidebar } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { default as InviteUser } from "@/assets/icons/invite_user.svg?react";
import { IconUserPlus } from "@tabler/icons-react";

export const InviteBox = () => {
  const { open } = useSidebar();

  if (!open) {
    return (
      <Button asChild className={"!al-bg-blue-50 !al-text-brand al-font-bold !al-p-2"}>
        <Link to={"/settings/users"} state={{ invite: true }}>
          <IconUserPlus />
        </Link>
      </Button>
    );
  }

  return (
    <Stack
      direction={"column"}
      gap={"none"}
      align={"center"}
      className="al-border al-p-2 al-rounded-md al-text-center"
    >
      <InviteUser />
      <div className="al-text-sm al-font-semibold">Invite User</div>
      <div className="al-text-xs al-text-muted-foreground">
        Invite your team members to collaborate and accelerate the work together
      </div>
      <Button asChild variant="secondary" className="al-w-full al-mt-2">
        <Link to={"/settings/users"} state={{ invite: true }}>
          Invite
        </Link>
      </Button>
    </Stack>
  );
};
